module.exports = __webpack_public_path__ + "static/patio-ecd00ad48f71537b2ecafbd03f49cfc2.jpeg";